import { CommonModule } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import type { TermAndCondition } from '@core/models/app.model';

import { ProviderService } from '../../../../provider/services/provider.service';
import { type ITermHistory, TERMS_AND_CONDITIONS_ACTION } from '../../models/services.model';

@UntilDestroy()
@Component({
  selector: 'ume-term-history-dialog',
  templateUrl: './term-history-dialog.component.html',
  standalone: true,
  imports: [
    MatTableModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class TermHistoryDialogComponent implements OnInit {
  readonly termAction = TERMS_AND_CONDITIONS_ACTION;

  public data: {
    term: TermAndCondition;
  } = inject(MAT_DIALOG_DATA);
  private providerService: ProviderService = inject(ProviderService);

  public term: TermAndCondition;
  public isLoading = true;

  public dataSource!: MatTableDataSource<ITermHistory>;
  public displayedColumns: string[] = ['date', 'action', 'by'];

  constructor() {
    this.term = this.data.term;
  }

  public ngOnInit(): void {
    this.providerService
      .getTermHistories(this.term.guid)
      .pipe(untilDestroyed(this))
      .subscribe((histories: ITermHistory[]) => {
        this.dataSource = new MatTableDataSource(histories);
        this.isLoading = false;
      });
  }

  public getTermAction(action: string): string {
    return this.termAction[action as keyof typeof TERMS_AND_CONDITIONS_ACTION];
  }
}
